//@import dependencies
import React, {useState} from 'react'
import { useTranslation } from 'react-i18next'
import {FiUsers} from 'react-icons/fi'
//@end

//@import components
import AppContainer from 'app_components/layouts/app'
import BreadcrumbComponent from 'app_components/commons/breadcrumb'
import DataTableComponent from 'app_components/commons/dataTable'
import CompanyForm from 'app_components/modules/admin/company'
import CompanySkeleton from './companySkeleton'
import ModalCompanyUsersModule from 'app_components/modules/modalCompanyUsers'
//@end

// @import hooks
import {useColors} from 'app_hooks/useColors'
// @end

// @INFO Import types
import { IPagination } from 'app_types/pagination/paginationTypes'
import { ICompanyListItem } from 'app_types/admin/company/companyTypes'
// @end

// @INFO Import services
// @end

// @INFO Import Styles
import './../companyScreen.scss'

// @ADD Component types
interface ICompanyScreenLayoutProps {
  itemList: ICompanyListItem[]
  status: null | 'loading' | 'error'
  add: boolean
  edit: boolean
  view: boolean
  editData: any
  selectedRow: null | string
  pagination: IPagination
  addItem: any
  updateItem: any
  showAddForm: (add: boolean) => void
  showEditForm: (edit: boolean, editData?: any) => void
  onViewerRow: (view: boolean, editData?: any) => void
  onPageChange: (page: number) => void
  onRowClick: (row: any) => void
  removeItem: (userId: string) => void
  onSearch: (search: string) => void
}

const CompanyScreenLayout: React.FC<ICompanyScreenLayoutProps> = (props) => {

  const { t } = useTranslation()
  const [colors] = useColors()

  const [modalCompanyUsersStatus, setModalCompanyUsersStatus] = useState<{status: boolean, company: ICompanyListItem | null}>({status: false, company: null})

  const openCompanyUsersModal = (company: ICompanyListItem) => {
    setModalCompanyUsersStatus({status: true, company})
  }

  const handleCloseCompanyUsersModal = (data: any) => {
    setModalCompanyUsersStatus({status: false, company: null})
  }

  return(
    <AppContainer>
      <div className='container-fluid'>
        <BreadcrumbComponent links={['#']} texts={[`${t('components.breadcrumb.companies')}`]} />

        <div className='company-screen'>

          {props.status === 'loading' && (
            <CompanySkeleton />
          )}

          {props.status !== 'loading' && !props.add && !props.edit && !props.view && (
            <>
              <h2>{t('screens.companies.title')}</h2>

              <DataTableComponent
                data={props.itemList}
                headerKeys={[
                  `${t('components.dataTable.headers.company.slug')}`,
                  `${t('components.dataTable.headers.company.name')}`
                ]}
                keys={['slug', 'name']}
                selectedRow={props.selectedRow}
                pagination={props.pagination}
                detailsKey={[]}
                onSearch={props.onSearch}
                onAddRow={props.showAddForm}
                onClickRow={props.onRowClick}
                onRemoveRow={props.removeItem}
                onPageChange={props.onPageChange}
                onEditRow={props.showEditForm}
                onViewerRow={props.onViewerRow}
                onModal={null}
                rowButtons={(company: ICompanyListItem) => {
                  return (
                    <>
                      <button
                        className='btn btn-link btn-sm'
                        data-tip={t('screens.companies.company_users')}
                        onClick={() => openCompanyUsersModal(company)}
                      >
                        <FiUsers size="20px" color={colors.primary} />
                      </button>
                    </>
                  )
                }}
              />
            </>
          )}

          {props.add && (
            <div className="company-container-form col-6 mb-3">
              <div className="d-flex align-items-center mb-2">
                <h2 className="form-title">
                  {t("screens.companies.add_layout.title_page")}
                </h2>
                <button className="btn btn-light btn-sm border ml-2" onClick={() => props.showAddForm(false)}>
                  {t("buttons.back")}
                </button>
              </div>
              <CompanyForm
                onHandleSubmit={props.addItem}
                viewer={false}
              />
            </div>
          )}

          {(props.edit || props.view) && props.editData && (
            <div className="company-container-form col-6 mb-3">
              <div className="d-flex align-items-center mb-2">
                {props.edit && (
                  <>
                    <h2 className="form-title">
                      {t("screens.companies.edit_layout.title_page")}
                    </h2>
                    <button className="btn btn-light btn-sm border ml-2" onClick={() => props.showEditForm(false)}>
                      {t("buttons.back")}
                    </button>
                  </>
                )}
                {props.view && (
                  <>
                    <h2 className="form-title">
                      {t("screens.companies.view_layout.title_page")}
                    </h2>
                    <button className="btn btn-light btn-sm border ml-2" onClick={() => props.onViewerRow(false)}>
                      {t("buttons.back")}
                    </button>
                  </>
                )}
              </div>
              <CompanyForm
                editData={props.editData}
                onHandleSubmit={props.updateItem}
                viewer={props.view}
              />
            </div>
          )}

          {modalCompanyUsersStatus.status && modalCompanyUsersStatus.company && (
            <ModalCompanyUsersModule
              open={modalCompanyUsersStatus.status}
              handleClose={handleCloseCompanyUsersModal}
              company={modalCompanyUsersStatus.company}
            />
          )}
        </div>
      </div>
    </AppContainer>
  )
}

export default CompanyScreenLayout
